"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["href"];
const _hoisted_2 = ["href"];
const _hoisted_3 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("tr", null, [
        (0, vue_1.createElementVNode)("td", null, [
            (0, vue_1.createElementVNode)("span", {
                class: (0, vue_1.normalizeClass)(_ctx.statusClass)
            }, null, 2)
        ]),
        (0, vue_1.createElementVNode)("td", null, [
            (0, vue_1.createElementVNode)("a", {
                href: 'game?id=' + _ctx.id,
                class: "game-id"
            }, (0, vue_1.toDisplayString)(_ctx.id), 9, _hoisted_1)
        ]),
        (_ctx.game !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.game.players, (player) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", {
                        key: player.color
                    }, [
                        (0, vue_1.createElementVNode)("span", {
                            class: (0, vue_1.normalizeClass)(["player-name", 'player_bg_color_' + player.color])
                        }, [
                            (0, vue_1.createElementVNode)("a", {
                                calassc: "",
                                target: "blank",
                                href: 'player?id=' + player.id
                            }, (0, vue_1.toDisplayString)(player.name), 9, _hoisted_2)
                        ], 2)
                    ]));
                }), 128)),
                (0, vue_1.createElementVNode)("td", null, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        target: "blank",
                        href: 'spectator?id=' + _ctx.game.spectatorId,
                        class: "player-name spectator"
                    }, [...(_cache[0] || (_cache[0] = [
                            (0, vue_1.createTextVNode)("Spectator", -1)
                        ]))], 8, _hoisted_3)), [
                        [_directive_i18n]
                    ])
                ])
            ], 64))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
